import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MailMergeCategoryProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'MailMergeCategory', method: 'GET', secure: true });
    }, [execute]);  

    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMailMergeCategoryStore = () => React.useContext(Context);
